/**
 * Pushes a pageview event to the dataLayer.
 * @param {string} url - The URL of the page being viewed.
 */
export const pageview = (url) => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'page_view', // Standard GTM event name
      page_path: url,     // Standard GTM parameter
    });
  }
};

/**
 * Pushes a custom event to the dataLayer.
 * @param {object} params - The event parameters.
 * @param {string} params.action - The event action.
 * @param {string} [params.category] - The event category.
 * @param {string} [params.label] - The event label.
 * @param {number} [params.value] - The event value.
 */
export const event = ({ action, category, label, value }) => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'custom_event',
      event_action: action,
      event_category: category,
      event_label: label,
      event_value: value,
    });
  }
};